import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, User, Settings } from "lucide-react";

const Sidebar = () => {
  const location = useLocation();

  const menuItems = [
    { name: "Dashboard", icon: <Home size={20} />, path: "/dashboard" },
    { name: "Profile", icon: <User size={20} />, path: "/profile" },
    { name: "Settings", icon: <Settings size={20} />, path: "/settings" },
  ];

  return (
    <div className="h-screen w-64 bg-gradient-to-br from-[#004687] to-[#007BFF] text-white flex flex-col shadow-lg fixed left-0 top-0">
      {/* Logo */}
      <div className="p-5 text-lg font-semibold text-center border-b border-white/20">
        Centralized Login System
      </div>

      {/* Menu */}
      <div className="flex-1 p-4 space-y-2">
        {menuItems.map((item) => (
          <Link
            key={item.name}
            to={item.path}
            className={`flex items-center gap-3 px-4 py-2 rounded-xl transition-all duration-200 
              ${
                location.pathname === item.path
                  ? "bg-white text-[#004687] font-semibold"
                  : "hover:bg-white/20"
              }`}
          >
            {item.icon}
            <span>{item.name}</span>
          </Link>
        ))}
      </div>

      {/* Footer */}
      <div className="p-4 border-t border-white/20 text-sm text-center opacity-80">
        © 2025 CLS
      </div>
    </div>
  );
};

export default Sidebar;
